module.exports = __webpack_public_path__ + "a0af8fcc8944a07a591162aef42589c0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bb-cream/dark-swatch.jpg
 ** module id = 424
 ** module chunks = 0
 **/